import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";
import { useShowMore } from "../../../hooks/useShowMore";
import { BoldText, ButtonDiv, CruiseSubHeader, CruiseWrapper, Description, ListItem, ListTitle, ShowMoreButton, ShowMoreContent, SocialLink, StyledList, } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";

const Cruises = () => {
    const { t } = useTranslation("cruises");
    const { showAll, handleToggle, buttonRef } = useShowMore();


    const castlesItems = t("sections.castles.items", { returnObjects: true });
    const roundItems = t("sections.round.items", { returnObjects: true });
    const hoursItems = t("sections.hours.items", { returnObjects: true });
    const extraItems = t("sections.extra.items", { returnObjects: true });
    const marinaItems = t("sections.marina.items", { returnObjects: true });
    console.log("castlesItems:", castlesItems, typeof castlesItems);
    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => {
                if (item.type === "link") {
                    return (
                        <ListItem key={idx}>
                            <BoldText>{item.label} </BoldText>
                            {item.textBeforeLink}
                            <SocialLink
                                as={Link}
                                to="address"
                                smooth
                                duration={1000}
                                offset={-90}
                                style={{ cursor: "pointer" }}
                            >
                                {item.linkText}
                            </SocialLink>
                            {item.textAfterLink}
                        </ListItem>
                    );
                }

                return (
                    <ListItem key={idx}>
                        <BoldText>{item.label} </BoldText>
                        {item.text}
                    </ListItem>
                );
            })}
        </StyledList>
    );

    return (
        <CruiseWrapper>
            <StaggeredContainer>
                <ShowMoreContent $isVisible={showAll}>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.routes.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <ListTitle>{t("sections.castles.title")}</ListTitle>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(castlesItems)}</StaggeredItem>
                    <StaggeredItem>
                        <ListTitle>{t("sections.round.title")}</ListTitle>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(roundItems)}</StaggeredItem>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.hours.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <Description>{t("sections.hours.intro")}</Description>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(hoursItems)}</StaggeredItem>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.extra.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(extraItems)}</StaggeredItem>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.marina.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <Description>{t("sections.marina.intro")}</Description>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(marinaItems)}</StaggeredItem>
                </ShowMoreContent>
                <ButtonDiv>
                    <ShowMoreButton onClick={handleToggle} ref={buttonRef}>
                        {showAll ? t("toggle.hide") : t("toggle.show")}
                    </ShowMoreButton>
                </ButtonDiv>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Cruises;